import { Injectable } from '@angular/core';
import { TarifrechnerAppConfiguration } from '@vhv/tarifrechner-common';
import {environment} from "../environments/environment";

@Injectable({
    providedIn: 'root',
})
export class AppConfiguration {

    constructor(tarifrechnerConf: TarifrechnerAppConfiguration) {
        tarifrechnerConf.setApplicationName(this.applicationName);
        tarifrechnerConf.setProductionMode(environment.production);
        tarifrechnerConf.setRestParentPath(this.restParentPath);
        tarifrechnerConf.setOberflacheDefinitionLazyFetch(this.restPaths.oberflacheDefinition.lazyFetch);
        tarifrechnerConf.setOberflacheDefinitionPath(this.restPaths.oberflacheDefinition.path);
        tarifrechnerConf.setOberflacheFunktionLazyFetch(this.restPaths.oberflacheFunktion.lazyFetch);
        tarifrechnerConf.setOberflacheFunktionPath(this.restPaths.oberflacheFunktion.path);
        tarifrechnerConf.setOberflacheWertebereicheLazyFetch(this.restPaths.oberflacheWertebereiche.lazyFetch);
        tarifrechnerConf.setOberflacheWertebereichePath(this.restPaths.oberflacheWertebereiche.path);
        tarifrechnerConf.setTarifierungBeitragLazyFetch(this.restPaths.tarifierungBeitrag.lazyFetch);
        tarifrechnerConf.setTarifierungBeitragPath(this.restPaths.tarifierungBeitrag.path);
        tarifrechnerConf.setTarifierungSetAntragLazyFetch(this.restPaths.tarifierungSetAntrag.lazyFetch);
        tarifrechnerConf.setTarifierungSetAntragPath(this.restPaths.tarifierungSetAntrag.path);
        tarifrechnerConf.setAdressPruefungPath(this.restPaths.pruefungAdresse.path);
        tarifrechnerConf.setAdressPruefungLazyFetch(this.restPaths.pruefungAdresse.lazyFetch);
        tarifrechnerConf.setBankdatenPruefungPath(this.restPaths.pruefungBankdaten.path);
        tarifrechnerConf.setBankdatenPruefungLazyFetch(this.restPaths.pruefungBankdaten.lazyFetch);
        tarifrechnerConf.setWiedereinsprungLadenPath(this.restPaths.wiedereinsprungLaden.path);
        tarifrechnerConf.setWiedereinsprungLadenLazyFetch(this.restPaths.wiedereinsprungLaden.lazyFetch);
        tarifrechnerConf.setWiedereinsprungSpeichernPath(this.restPaths.wiedereinsprungSpeichern.path);
        tarifrechnerConf.setWiedereinsprungSpeichernLazyFetch(this.restPaths.wiedereinsprungSpeichern.lazyFetch);
        tarifrechnerConf.setWiedereinsprungEmailPath(this.restPaths.wiedereinsprungEmail.path);
        tarifrechnerConf.setWiedereinsprungEmailLazyFetch(this.restPaths.wiedereinsprungEmail.lazyFetch);
        tarifrechnerConf.setNeoskopBrokerUrl(environment.neoskopBrokerUrl);
        tarifrechnerConf.setLogoUrl(environment.logoUrl);
        tarifrechnerConf.setDankeSeiteUrl(environment.dankeSeiteUrl);
        tarifrechnerConf.setSidebarPrimaryRate('gesamtJahresNettoBeitrag');
        tarifrechnerConf.setSidebarSecondaryRate('gesamtJahresBruttoBeitrag');
        tarifrechnerConf.setSidebarPrimaryText('Unverbindlicher Nettobeitrag:');
        tarifrechnerConf.setSidebarSecondaryText('Brutto:');
        tarifrechnerConf.setBruttoOben(false);
    }

    readonly applicationName =  'VHV Baugeräte';

    readonly baseHref = '/web';

    /* Common messages */
    readonly messages = {
        uploadFileToLarge: 'Die Datei "$fileName" ist zu groß ($fileSize MB). Max. zulässige Dateigröße: $max MB.',
        uploadFilesToMany: '$numFilesRequest Dateien überschreiten das Limit. Sie können nur bis zu $numFiles Datei(en) hochladen.',
        uploadFilesWrongType: 'Entschuldigung. Wir konnten die Datei $fileName nicht verarbeiten.',
        uploadFileSumTooLarge: 'Zulässige Gesamtgröße aller Dateien: max. $max MB. (Ihre Dateien: $fileSize MB)',
        jahresabschlussFileTypeMsg: 'Zulässige Dateiformate: *. xbrl, *.xml, *. pdf, *.doc, *.docx, *. odt, *.rtf, *.xls, *.xlsx, *.ods, *.txt',
        bgAntragFremdformulareFileTypeMsg: 'Zulässige Dateiformate: *.pdf, *.doc, *.docx, *.odt, *.txt, *rtf, *.xls, *.xlsx, *.ods, *.bmp, *.png, *.jpg, *.gif, *.tif, *.tiff, *.ppt',
        registrationZugangsdatenNichtkorrekt: 'Die eingegebenen Zugangsdaten zur Verifizierung sind nicht korrekt.',
        registrationErrorSachbearbeiter: 'Eine Verifizierung der Zugangsdaten ist nicht möglich. Wenden Sie sich an Ihren Sachbearbeiter.',
        partnerAenderungDetails1: 'Die Änderung wird in den nächsten Tagen durchgeführt.',
        partnerAenderungDetails2: 'Erst dann ist die Änderung im Kreditportal sichtbar.',
        partnerAenderungSuccess: 'Übermittlung erfolgreich.',
        userAnlegenDetails: 'Der neu angelegte Benutzer erhält in Kürze eine E-Mail zur Vergabe eines neuen Passworts.',
        noMessages: 'Sie haben keine aktuellen Meldungen.',
        maxObligoExtended: 'Die maximale Anzahl von Obligolisten wurde heute bereits abgerufen. Die Funktion steht Ihnen morgen wieder zur Verfügung.',
        registrationCheckNotFound: 'Möglicherweise wurde die Registrierung bereits abgeschlossen. Sie können sich auf der Login-Seite mit Ihren Zugangsdaten anmelden.',
        registrationVerifyNotFound: 'Möglicherweise wurde die Registrierung bereits abgeschlossen. Sie können sich mit Ihren Zugangsdaten anmelden.',
        registrationVerifyUserNotFound: 'Es ist kein offener Vorgang zur Aktivierung Ihres Nutzer-Accounts vorhanden. Sie können sich mit Ihren Zugangsdaten anmelden.',
        passwortResetTokenNotValid: 'Der Link zur Vergabe eines neuen Passwortes ist nicht mehr gültig. Verwenden Sie die Funktion "Zugangsdaten vergessen" erneut, um eine neue E-Mail mit einem neuen Link zu erhalten.',
        passwortResetLocked: 'Die Funktion "Zugangsdaten vergessen" wurde aus Sicherheitsgründen gesperrt, da zu viele Passwortwiederherstellungen angefordert wurden. Bitte prüfen Sie, ob Sie unter der hinterlegten E-Mail-Adresse eine entsprechende E-Mail erhalten haben. Sollten Sie kein neues Passwort mehr vergeben können, wenden Sie sich bitte an Ihren Sachbearbeiter.',
    };


    readonly httpErrorMessages = {
        '_500': {
            headline: 'Es ist ein Fehler aufgetreten.',
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_404': {
            headline: 'Es ist ein Fehler aufgetreten.',
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_401': {
            headline: 'Es ist ein Fehler aufgetreten.',
            details: ['Sie haben keine Berechtigung.',
                'Möglicherweise ist Ihre Sitzung abgelaufen.'],
        },
        '_400': {
            headline: 'Es ist ein Fehler aufgetreten.',
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_406': {
            headline: 'Es ist ein Fehler aufgetreten.',
            details: ['Wir akzeptieren diese Anfrage aufgrund hier angegebener Regeln nicht.'],
        },
        '_423': {
            headline: 'Ihr Account wurde gesperrt.',
            details: ['Ihr Account wurde gesperrt, verwenden Sie bitte die Funktion „Zugangsdaten vergessen?“.'],
        },
        '_504': {
            headline: 'Es ist ein Fehler aufgetreten.',
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
        '_0': {
            headline: 'Unbekannter Fehler.',
            details: ['Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'],
        },
    };


    /* Rest service paths */
    restParentPath = '/fes';

    readonly restPaths = {
        configuration: {
            path: '/start/configuration',
            lazyFetch: true,
        },
        oberflacheDefinition: {
            path: '/oberflaeche/definition',
            lazyFetch: true,
        },
        oberflacheWertebereiche: {
            path: '/oberflaeche/werte',
            lazyFetch: true,
        },
        oberflacheFunktion: {
            path: '/oberflaeche/funktion',
            lazyFetch: true,
        },
        tarifierungBeitrag: {
            path: '/tarifierung/getBeitrag',
            lazyFetch: true,
        },
        tarifierungSetAntrag: {
            path: '/tarifierung/setAntrag',
            lazyFetch: true,
        },
        pdfPreisvorschlag: {
            path: '/pdf/preisvorschlag',
            lazyFetch: true,
        },
        pdfGebuendelterDownload: {
            path: '/pdf/gebuendelterDownload',
            lazyFetch: true,
        },
        pruefungAdresse: {
            path: '/pruefung/adresse',
            lazyFetch: true,
        },
        pruefungBankdaten: {
            path: '/pruefung/bankdaten',
            lazyFetch: true,
        },
        wiedereinsprungLaden: {
            path: '/wiedereinsprung/laden',
            lazyFetch: true,
        },
        wiedereinsprungSpeichern: {
            path: '/wiedereinsprung/speichern',
            lazyFetch: true,
        },
        wiedereinsprungEmail: {
            path: '/wiedereinsprung/sendeWiedereinsprungMail',
            lazyFetch: true,
        }
    };
}
